module.exports = __webpack_public_path__ + "img/GY.cb36adae.svg";